<div>
  <!-- Div to make sticky-top work on ios -->
  <app-static-container headerImage="5">
    <h1 appFocusOnInit id="titre-page" class="titre-page">{{ 'assurance-pret.header' | translate }}</h1>
    <h2 id="titre-section" class="titre-section">{{ 'assurance-pret.titre' | translate }}</h2>
    <section class="text-content">
      <p>{{ 'assurance-pret.texte' | translate }}</p>
      <div class="options">
        <div class="option">
          <app-green-label id="label-option-1" [label]="'assurance-pret.content-1.label' | translate">
          </app-green-label>
          <h3 id="sous-titre-option-1" class="sous-titre-option">{{ 'assurance-pret.content-1.titre' | translate }}</h3>
          <p class="texte">{{ 'assurance-pret.content-1.texte-1' | translate }}</p>
          <ul>
            <li>{{ 'assurance-pret.content-1.point-1' | translate }}</li>
            <li>{{ 'assurance-pret.content-1.point-2' | translate }}</li>
            <li>{{ 'assurance-pret.content-1.point-3' | translate }}</li>
            <li>{{ 'assurance-pret.content-1.point-4' | translate }}</li>
          </ul>
          <p class="texte">{{ 'assurance-pret.content-1.texte-2' | translate }}</p>
          <button *ngIf="!isOctroiCompleted" mat-button class="green full-width-xs" id="btn-rdv" (click)="navigate()">
            {{ 'general.btn-rdv' | translate }}
          </button>
        </div>
        <div class="option">
          <app-green-label id="label-option-2" [label]="'assurance-pret.content-2.label' | translate">
          </app-green-label>
          <h3 id="sous-titre-option-2" class="sous-titre-option">{{ 'assurance-pret.content-2.titre' | translate }}</h3>
          <p class="texte">{{ 'assurance-pret.content-2.texte-1' | translate }}</p>
          <p class="texte">{{ 'assurance-pret.content-2.texte-2' | translate }}</p>
          <div class="telephone-container">
            <a
              class="telephone primary dsd-mb-0"
              id="tel-pret-sans-frais"
              href="tel:+{{ telephoneAssurancePretSansFrais }}"
              (click)="updateDernierAppel()"
              title="{{ 'header.click-to-call.lien-telephonie' | translate }}"
            >
              <img
                id="icone-tel-pret-sans-frais"
                src="{{ 'assets/images/phone.svg' | cheminAbsoluStatique }}"
                alt="click-to-call"
                class="icone"
              />{{ telephoneAssurancePretSansFrais }}
            </a>
            <div id="texte-sans-frais" class="sans-frais">&nbsp;{{ 'general.sans-frais' | translate }}</div>
          </div>
          <div class="horaire" id="horaire" [innerHTML]="'horaire.assurance-pret' | translate"></div>
        </div>
      </div>
    </section>
  </app-static-container>
  <app-sub-footer [enableNextStep]="true" [nextStep]="'acte-vente'"></app-sub-footer>
</div>
